<template>
    <div class="rounded-3xl flex flex-col" :class="{ 'md:w-125 gap-10 p-6': cardType === 'dialog' }">
        <!-- Insight gradient -->
        <div
            class="w-full px-6 md:px-10 md:py-10 py-3 flex flex-col gap-2 gradient-border rounded-xl z-0"
            :class="{ 'max-w-100 md:h-75 py-10! mx-auto bg-white': cardType === 'onboarding', gradient: cardType !== 'onboarding' }">
            <div class="flex flex-row items-center gap-6">
                <!-- Lighting Icon -->
                <i class="bi bi-lightning-charge-fill text-xl text-valence-primary-500" aria-hidden="true"></i>
                <div class="body-small font-semibold text-valence-primary-500">{{ title }}</div>
            </div>
            <div class="title-subsection text-valence-grey-850 mt-4 w-full">{{ subtitle }}</div>
            <div v-if="cardType === 'onboarding'" class="flex flex-row w-full justify-between items-center md:mt-auto mt-4">
                <BaseButton theme="tertiary" @click="$emit('seeMore')"><p class="text-valence-primary-500">See more</p></BaseButton>
                <BaseButton theme="primary" class="w-30 leading-6 body-small whitespace-nowrap" type="submit" @click="$emit('diveDeeper')">Dive deeper</BaseButton>
            </div>
        </div>
        <template v-if="isDialog">
            <div class="md:overflow-y-auto md:max-h-64 body-small text-valence-grey-750">{{ content }}</div>
            <div class="flex flex-col items-center gap-3">
                <BaseButton theme="primary" class="w-fit leading-6 body-small" type="submit" @click="$emit('diveDeeper')">Dive deeper</BaseButton>
                <BaseButton theme="tertiary" class="w-fit leading-6 body-small whitespace-nowrap text-valence-primary-500" @click="$emit('close')">Dismiss</BaseButton>
            </div>
        </template>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import { computed } from "vue";

type InsightsCardProps = {
    cardType: "onboarding" | "dialog";
    title: string;
    subtitle: string;
    content: string;
    id: string;
};

const props = defineProps<InsightsCardProps>();

const isDialog = computed(() => props.cardType === "dialog");

defineEmits<{
    close: [];
    diveDeeper: [];
    seeMore: [];
}>();
</script>
